var $c31b6134a3770ee4$exports = {};
$c31b6134a3770ee4$exports = {
  "backButton": args => "Vend tilbage til ".concat(args.prevMenuButton),
  "moreActions": "Flere handlinger",
  "unavailable": "Ikke tilg\xE6ngelig, udvid for detaljer"
};
export { $c31b6134a3770ee4$exports as default };